"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var inlineBtoa_1 = __importDefault(require("@snapchat/metrics-utils/lib/utils/inlineBtoa"));
var isInBrowser_1 = require("@snapchat/metrics-utils/lib/utils/isInBrowser");
var sha256_1 = __importDefault(require("@snapchat/metrics-utils/lib/utils/sha256"));
var computeWebAttestation = function (binaryPayload) {
    var hexString = Array.prototype.map.call(binaryPayload, function (uint8) { return ("0" + uint8.toString(16)).slice(-2); }).join('');
    var hashString = sha256_1["default"].hash(hexString, { msgFormat: 'hex-bytes' });
    var headerString = hashString + ":" + Date.now();
    return isInBrowser_1.isInBrowser() ? btoa(headerString) : inlineBtoa_1["default"](headerString);
};
exports["default"] = computeWebAttestation;
//# sourceMappingURL=computeWebAttestation.js.map